module.exports = __webpack_public_path__ + "img/title@2x.8d1e9054.png";